/* DiscoveryStatusRenderer.js */

"use strict";

const _ = require("lodash");

class DiscoveryStatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("discovery-status-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("DiscoveryState", (this._onDiscoveryState = this._onDiscoveryState.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("DiscoveryState");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setDiscoveryState(this._model.getDiscoveryState());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDiscoveryState(newVal) {
        if (typeof newVal === "string") {
            this._setDiscoveryTextState(newVal);
        } else {
            this._setDiscoveryState(newVal);
        }
    }

    // _onTooltip(newVal) {
    //     this._setTooltip(newVal);
    // }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setDiscoveryState(newVal) {
        if (!_.isUndefined(newVal)) {
            const pristineProperties = newVal.getPristineProperties();
            const status = this._model._labels[pristineProperties.discoveryStatus];
            if (status) {
                this._rootElem.innerText = status;
            } else {
                this._rootElem.innerText = pristineProperties.discoveryStatus;
            }
        }
    }

    _setDiscoveryTextState(newVal) {
        const status = this._model._labels[newVal];
        if (status) {
            this._rootElem.innerText = status;
        } else {
            this._rootElem.innerText = newVal;
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = DiscoveryStatusColumnRenderer;
